import Vue from 'vue';
import { storage } from "@/firebase.js";

export default {
    state: {},
    mutations: {},
    getters: {},
    actions: {
        async uploadImage({},data) {
            var date = new Date();
            let name = data.file.name;
            var timestamp = date.getTime();
            let firesto = data.cia.firebase_firestore;
            let ref = firesto + "/config/slides/" + timestamp + name;
            let refStorage = storage.ref(ref);
            await refStorage.put(data.file);
            let url = await refStorage.getDownloadURL();
            return url;
        },
    }
}


// WEBPACK FOOTER //
// ./src/modules/editor.js